<template>
  <div class="public">
    <label class="public__row">
      <input
        class="public__input"
        type="checkbox"
        role="switch"
        :checked="isPublic"
        :disabled="!isVisibilityLoaded || isSavingVisibility"
        @change="(e) => store.dispatch('Briefcase/setVisibility', e.target.checked)"
      />
      <span class="public__switch" aria-hidden="true"></span>
      <span class="public__text">Показывать мой портфель в рейтинге</span>
    </label>
    <p class="public__hint">Имя, аватар и состав портфеля увидят подписчики.</p>
    <p class="public__hint">В рейтинг попадают портфели от двух криптомонет.</p>
    <p class="public__error" v-if="visibilityError">{{ visibilityError }}</p>
  </div>
</template>

<script setup>
  import { onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useBriefcaseState } from '@/Groups/Briefcase/private/composables/computedValues';
  //------------------------
  const store = useStore();
  const { isPublic, isSavingVisibility, isVisibilityLoaded, visibilityError } = useBriefcaseState();
  //------------------------
  onMounted(() => {
    if (!store.state.Briefcase.isVisibilityLoaded) store.dispatch('Briefcase/loadVisibility');
  });
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>
